export const FACTOR_RULE_TYPES = {
  FACTOR: "factor",
  BETA: "beta",
  COUNTRY: "country",
  CURRENCY: "currency",
  CLASSIFICATION: "classification",
} as const

export const FACTOR_RULE_DISPLAY_TYPES = {
  EXPOSURE: "exposure",
  COMPOSITION: "composition",
} as const

export const DEFAULT_TAB_ORDER = {
  all: 0,
  style: 1,
  country: 2,
  currency: 3,
  sector: 4,
} as const
